module.exports = __webpack_public_path__ + "static/tile-hey-polls-7c391d05867942c17117d26b7e0369dd.png";